import { createTheme } from "@mui/material/styles";

export const colors = {
  darkCharcoal: "#333",
  catch22: "#222",
  blueSteel: "#374C60",
  blueSteelLight: "#63788d",
  blueSteelDark: "#0c2436",
};
export const muiTheme = createTheme({
  palette: {
    mode: "dark",
    common: {
      gray: "#999",
    },
    primary: {
      main: "#34abcf",
      contrastText: "#fff",
    },
    secondary: {
      main: "#D64045",
    },
    text: {
      primary: "rgba(204, 204, 204, 1)",
      title: "#ffffff",
    },
    background: {
      default: "#202124",
      paper: "#222326",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.25rem",
      color: "#ffffff",
    },
    h2: {
      fontSize: "1.75rem",
      color: "#ffffff",
    },
    h3: {
      fontSize: "1.5rem",
      color: "#ffffff",
    },
    h4: {
      fontSize: "1.25rem",
      color: "#ffffff",
    },
    h5: {
      fontSize: "1rem",
      color: "#ffffff",
    },
    h6: {
      fontSize: "1rem",
      color: "#ffffff",
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        color: "inherit",
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "20px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          "& * .card-title": {
            // todo: obsolete?
            color: "#ffffff",
          },
        },
      },
    },
    MuiDialogTitle: {
      defaultProps: {
        variant: "h3",
        color: "#ffffff",
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 18,
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
    },
    MuiListItemText: {
      defaultProps: {
        slotProps: {
          primary: {
            variant: "h4",
          },
          secondary: {
            variant: "body1",
          },
        },
      },
      styleOverrides: {
        root: {
          "& > .MuiListItemText-primary": {
            color: "#ffffff",
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          ".MuiDialog-paper": {
            backgroundImage:
              "linear-gradient(rgba(255, 255, 255, 0.10), rgba(255, 255, 255, 0.10))",
          },
        },
      },
    },
    MuiPopover: {
      defaultProps: {
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "center",
        },
        slotProps: {
          backdrop: {
            invisible: false,
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.MuiTab-root": {},
          "&.MuiTab-labelIcon": {
            minHeight: "inherit",
          },
          "&.MuiTab-labelIcon .MuiTab-iconWrapper > *:first-of-type": {
            marginBottom: "inherit",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
        slotProps: {
          inputLabel: {
            shrink: true,
          },
        },
      },
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            backgroundColor: "rgba(0,0,0,0.1)",
          },
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        color: "text.primary",
      },
      styleOverrides: {
        root: {
          "& strong": {
            color: "rgb(230,230,230)",
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: (theme) => ({
        html: {
          backgroundColor: theme.palette.background.default,
        },
        body: {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
        },
        "#__next": {
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,
        },
      }),
    },
  },
});
